import React from 'react';
import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  IPaginationProps,
  LinearProgress,
  LoadedContent,
} from '@occc/ui-design-system';
import { LoyaltyEventsListItemFragment } from '@occc/graphql';

import { LoyaltyEventTableRow } from './LoyaltyEventTableRow';

type LoyaltyEventTableProps = {
  offers: LoyaltyEventsListItemFragment[] | null | undefined;
  loading: boolean;
  error?: ApolloError;
  onRowClick: (id: string) => void;
  paginationProps: IPaginationProps;
  isEditActionVisible: boolean;
  isArchiveActionVisible: boolean;
};

export const LoyaltyEventTable: React.FC<LoyaltyEventTableProps> = ({
  offers,
  loading,
  error,
  onRowClick,
  paginationProps,
  isEditActionVisible,
  isArchiveActionVisible,
}) => {
  const areActionsVisible = isEditActionVisible || isArchiveActionVisible;

  const renderData = (items: LoyaltyEventsListItemFragment[]) => {
    return (
      <>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Loyalty Event Offer Name</TableCell>
              <TableCell>Marketing Content</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Configured for Manual Trigger</TableCell>
              <TableCell align='center'>Fulfillments</TableCell>
              {areActionsVisible && <TableCell align='right'>Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <LoyaltyEventTableRow
                key={item.id}
                offer={item}
                onItemClick={onRowClick}
                isEditActionVisible={isEditActionVisible}
                isArchiveActionVisible={isArchiveActionVisible}
                areActionsVisible={areActionsVisible}
              />
            ))}
          </TableBody>
        </Table>
        <Pagination {...paginationProps} />
      </>
    );
  };

  return (
    <LoadedContent<LoyaltyEventsListItemFragment>
      error={error}
      loading={loading}
      items={offers}
      renderData={renderData}
    />
  );
};
